// extracted by mini-css-extract-plugin
module.exports = {"fontHeight":"1rem","icon":"LdapBindDnInput__icon"};